import { formatCurrency } from './formatCurrency';
import { formatItemPrice } from './formatItemPrice';
import { IntlShape } from 'react-intl';

const formatCredits = (value: number, intl: IntlShape) => {
  return intl.formatMessage({ id: 'credits' }, { count: value });
};

export const getPaymentDetailsValues = (
  price: number,
  total: number,
  subtotal: number,
  taxSummary: number,
  discountApplied: number,
  currencyType: string,
  buildingLocale: string,
  intl: IntlShape,
  discountAmount?: number,
  isCreditsPayment?: boolean,
) => {
  if (isCreditsPayment) {
    return {
      itemPrice: price ? formatCredits(price, intl) : intl.formatMessage({ id: 'free' }),
    };
  }

  return {
    itemPrice: formatItemPrice(price, intl, currencyType, buildingLocale),
    subtotalValue: formatCurrency(subtotal, currencyType, buildingLocale),
    taxValue: formatCurrency(taxSummary, currencyType, buildingLocale),
    totalValue: formatCurrency(total, currencyType, buildingLocale),
    ...(discountAmount && {
      discountValue: formatCurrency(discountApplied, currencyType, buildingLocale, true, true),
      discountAmount: intl.formatMessage({ id: 'discount_amount' }, { amount: discountAmount }),
    }),
  };
};
